export const OnboardingSortByActionsEnum = {
  CreatedAtASC: {
    key: 1,
    label: 'created-at-asc',
    sort_by: 'created_at',
    order: 'asc',
  },
  CreatedAtDESC: {
    key: 2,
    label: 'created-at-desc',
    sort_by: 'created_at',
    order: 'desc',
  },
};
